export default __webpack_public_path__ + "static/media/gallery03.05383100.png";